import React from 'react';
import styled from 'styled-components';

import {
  Button,
  Fade,
  Menu,
  MenuItem,
  Paper as MuiPaper,
  ListProps,
  ButtonProps,
  Color,
} from '@mui/material';

import { ArrowDropDown } from '@mui/icons-material';

import { spacing } from '@mui/system';

export type TransitionMenuPropsType = {
  anchorEl: null | HTMLElement;
  menuItems: Array<string>;
  selectedItem: string | any;
  open: boolean;
  isLoading: boolean;
  buttonVariant?: ButtonProps | any;
  buttonColor?: Color | any;
  handleMenuClick: (e: any) => void;
  handleMenuItemClick: (item: string | any) => void;
  handleMenuClose: () => void;
  accessorFn?: (item: string) => string;
  defaultText?: string;
};

function TransitionMenu(props: TransitionMenuPropsType) {
  const {
    anchorEl,
    selectedItem,
    open,
    menuItems,
    handleMenuClick,
    handleMenuClose,
    handleMenuItemClick,
    isLoading,
    accessorFn,
    buttonVariant = 'contained',
    buttonColor = 'secondary',
    defaultText = 'Select an option',
  } = props;

  return (
    <>
      {' '}
      <Button
        aria-owns={anchorEl ? 'transition-menu' : undefined}
        aria-haspopup="true"
        onClick={(e) => handleMenuClick(e)}
        variant={buttonVariant}
        color={buttonColor}
        disabled={isLoading}
      >
        {(accessorFn ? accessorFn(selectedItem) : selectedItem) || defaultText}
        <ArrowDropDown />
      </Button>
      <Menu
        id="transition-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        TransitionComponent={Fade}
      >
        {menuItems.map((item) => (
          <MenuItem onClick={() => handleMenuItemClick(item)} key={item}>
            {accessorFn ? accessorFn(item) : item}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default React.memo(TransitionMenu);
